import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main__section reset-password__completed" }
const _hoisted_2 = { class: "box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", null, _toDisplayString(_ctx.userName), 1),
      _createVNode("span", null, _toDisplayString(_ctx.t('password changed')), 1)
    ])
  ]))
}